import React, { FC, memo } from 'react'
import s from './BuildInput.module.sass'
import { InputTitle } from '@shared/ui/Form/Single/InputTitle'
import { Input } from '@shared/ui/Form/Single/Input'
import { InputHint } from '@shared/ui/Form/Single/InputHint'
import { useFieldHint } from '@shared/lib/fields/hooks/useFieldHint/useFieldHint'
import {FieldBase, FieldInput, FieldInputTel} from '@shared/types/fields/fields'
import { ErrorBoundary } from '../../../../lib/components/ErrorBoundary'

interface Props {
  field: FieldBase | FieldInput | FieldInputTel
  setField: React.Dispatch<React.SetStateAction<FieldBase>>
  // eslint-disable-next-line
  handleChange?: (value: string) => void
  className?: string
}

const BuildInput: FC<Props & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = ({
  field,
  setField,
  handleChange,
  className = '',
  ...props
}) => {
  const [hint] = useFieldHint(field)

  const setValue = (value: string): void => {
    setField((prev) => ({
      ...prev,
      value: value,
      error: '',
    }))

    handleChange && handleChange(value)
  }

  const classes = {
    disabled: !field.value && field.disabled ? s.disabled : '',
    disabledValue: !!field.value && field.disabled ? s.disabled__value : '',
  }

  return (
    <ErrorBoundary>
      {field.visible && (
        <div className={`${s['input-group']} ${classes.disabled} ${classes.disabledValue} ${className}`} {...props}>
          <InputTitle
            nameField={field.name}
            title={field.settings.label}
            showRequired={field.required && field.settings.showRequired}
          />

          <Input field={field} handleValue={setValue} />

          <InputHint text={hint.text} status={hint.status} className={s['form-hint']} />
        </div>
      )}
    </ErrorBoundary>
  )
}

export default memo(BuildInput)
